import * as React from "react";
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import DropZoneField from '../Config/DropZone';
import api from "../Config/HttpFeasibility";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { Link } from "react-router-dom";
import es from 'date-fns/locale/es';
import { Field, reduxForm } from 'redux-form';
import { useHistory } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import Modal from '../../../../shared/components/Modal';
import moment from 'moment';

registerLocale('es', es);
const QuestionarySend = ({ feasibility, finishProcess }) => {

    const history = useHistory();

    const [comment, setComment] = React.useState(null);
    const [email, setEmail] = React.useState(null);

    const [file, setFile] = React.useState(null);

    const [isLoading, setIsLoading] = React.useState(false);

    const [showModal, setShowModal] = React.useState(false);
    const [messageModal, setMessageModal] = React.useState(null);
    const [colorModal, setColorModal] = React.useState("success");

    const openModal = (success, message) => {
        if (success == true) {
            setColorModal("success");
        }
        else {
            setColorModal("danger");
        }
        setShowModal(true);
        setMessageModal(message);
    }

    const { t } = useTranslation('common');
    const params = feasibility;

    const handleFocus = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const validateComment = () => {
        if (comment == null || comment.length < 1) {
            openModal(false,t('msg.comment_require'));
            return false;
        } else {
            return true;
        }
    }

    const validate = async () => {

        if (file != null) {
            var dataFile = new FormData();
            dataFile.append("archivo", file);
            dataFile.append("id_factibilidad", params.id_factibilidad);
            dataFile.append("observaciones", comment);
            sendRequest(dataFile);
        }
        else {
            openModal(false,t('msg.file_empty'));
        }
    }

    const sendRequest = async (_dataJson) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + 'factibilidad/subecuestionario_envio', {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: _dataJson
        }).then(response => {
            sendEmail();
        }).catch(error => console.error(error));
    }

    //Envio de Correo
    const sendEmail = async () => {
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        let date = moment(new Date()).format("YYYY/MM/DD");

        var dataFileMail = new FormData();
        dataFileMail.append("id_factibilidad", params.id_factibilidad);
        dataFileMail.append("acronimo", params.acronimo);
        dataFileMail.append("archivo", file);
        dataFileMail.append("emails", email);
        dataFileMail.append("observacion", comment);
        dataFileMail.append("usuario", usuario.nombre);
        dataFileMail.append("date", date);
        dataFileMail.append("imagen", sessionStorage.getItem('imagen') != null && sessionStorage.getItem('imagen') != 'null' ? sessionStorage.getItem('imagen'):null);
        dataFileMail.append("id_clinica", sessionStorage.getItem('id_clinica'));
        dataFileMail.append("nombre_empresa",sessionStorage.getItem('nombre_empresa'));
        dataFileMail.append("localidad",sessionStorage.getItem('localidad'));

        //let url = process.env.REACT_APP_PUBLIC_URL;
        let url = process.env.REACT_APP_PUBLIC_URL;
        setIsLoading(true);
        fetch(url + "factibilidad/send_email_factibilidad", {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataFileMail
        }).then(response => response.json()).then(data => {
            openModal(true,data.contenido);
            setIsLoading(false);
            finishProcess(data.archivos);
        }).catch(error => openModal(false,"Error en el envio de correo"));
    }

    return (<Container>
        <Row>
            <Col >
                <Card className="card--flex">
                    <CardBody className="width_static">
                        <form className="form form_vertical" >
                            <div className="form__form-group txt-area">
                                <span className="form__form-group-label">{t('confidentiality.comment')}</span>
                                <div className="form__form-group-field">
                                    <textarea onBlur={handleFocus} onFocus={handleFocus}
                                        onChange={({ target: { value } }) => setComment(value)}></textarea>
                                </div>
                            </div>

                            <div className="form__form-group">
                                <span className="form__form-group-label">{t('feasibility.email')}</span>
                                <div className="form__form-group-field">
                                    <input onBlur={handleFocus} onFocus={handleFocus}
                                        onChange={({ target: { value } }) => setEmail(value)} />
                                </div>
                            </div>

                            <div className="form__form-group">
                                <input accept="application/pdf" id="confidentialityFile" name="confidentialityFile" type="file" onChange={(e) => { setFile(e.target.files[0]) }} />
                            </div>

                            <ButtonToolbar className="form__button-toolbar">
                                <Button color="primary" type="button"
                                    onClick={() => validate()}>
                                    {t('btn.upload')}</Button>
                            </ButtonToolbar>
                        </form>
                        <div className="text-center">
                            {isLoading ? (<div>
                                <Spinner animation="border" variant="success" />
                            </div>) : (<></>)}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
        <Modal
                color={colorModal}
                title={messageModal}
                modal={showModal}
                onOk={() => setShowModal(false)}
                toggle={() => setShowModal(false)}
            />
    </Container>);
}

export default reduxForm({
    form: 'confidentiality_form', // a unique identifier for this form
})(QuestionarySend);